module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1182.87ae42fc.png";